import { createAction, createAsyncAction } from "typesafe-actions";

import { toStateObject } from "../../lib/helpers";
import { LocationStatePayload } from "./types";
import { AsyncThunkResult } from "../redux-types";
import { fetchGeolocation } from "../../lib/utils";
const  fetchLocationState = createAsyncAction(
  "geolocation/REQUEST",
  "geolocation/SUCCESS",
  "geolocation/FAILED"
)<void, LocationStatePayload, string>();

console.log(fetchLocationState)

export {fetchLocationState}
export const fetchLocationThunk = (): AsyncThunkResult<void> => async (
  dispatch
) => {
  // Tell Redux were requesting data from the db
  dispatch(fetchLocationState.request());
  try {
    // Do the actual request
    const mutatedLocation = await fetchGeolocation();
    console.log(`Did Request`)
    dispatch(fetchLocationState.success(mutatedLocation));
  } catch (err) {
    // Catch the err
    console.log(`Catching Err`)
    dispatch(fetchLocationState.failure(err.toString()));
  }
};

export const updateLocationState = createAction(
  "locationState/UPDATE",
  (locationStateShortName) => {
    return toStateObject(locationStateShortName, true);
  }
)();

export const setPipa = createAction("pipa/SET")();

export const toggleModal = createAction("modal/UPDATE")();
